'use client'

import { ListingSection } from '@components/app/ListingPage/TableOfContents/ListingSection'
import GeolocationProvider from '@components/hooks/GeolocationProvider/index.client'
import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import dynamic from 'next/dynamic'

// Dynamically import the Map component so it only loads on the client, and is not included in the initial bundle
const Trial2ListingMap = dynamic(
  async () => import('@components/app/LocationMap/Trial2ListingMap'),
  {
    ssr: false,
  },
)

export const Trial2ListingMapContainer = ({
  trial,
}: {
  trial: ClinicalTrialForListingPage
}) => {
  return (
    <ListingSection id='logistics' title='Find a Clinic Near You'>
      <GeolocationProvider>
        <Trial2ListingMap trialLocations={trial.trialLocations} />
      </GeolocationProvider>
    </ListingSection>
  )
}
